import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=17e0e95c&scoped=true"
import script from "./OrganizationForm.vue?vue&type=script&lang=js"
export * from "./OrganizationForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizationForm.vue?vue&type=style&index=0&id=17e0e95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e0e95c",
  null
  
)

export default component.exports